export const required = value => (value ? undefined : 'Pole wymagane')
